import { action } from './api';

/**
 * Updates the error splash screen state with the specified options.
 *
 * @param {boolean} open - Determines if the error splash screen should be displayed.
 * @param {object} options - An optional object to provide additional settings for the error splash screen.
 * @param {string} options.message - The message to display on the error splash screen. Default is 'Please contact MindCloud support.'.
 * @param {Array<string>} options.actions - An array of strings representing additional actions. Default is an empty array.
 *
 * Supported actions:
 * - 'CLOSE': Closes the error splash screen.
 * - 'SIGN_OUT': Signs out the user.
 * - 'RELOAD': Reloads the page.
 *
 * @example
 * // Example usage:
 * setErrorSplashScreen(true, {
 *   message: 'An error occurred. Please try again later.',
 *   actions: ['CLOSE', 'SIGN_OUT', 'RELOAD']
 * });
 */
const setErrorSplashScreen = (open, options = {}) => {
  // Update the error splash screen state with the specified options
  action('UPDATE_ERROR_SPLASH_SCREEN', { open, ...options });
};

export default setErrorSplashScreen;
